export default __webpack_public_path__ + "static/media/car5.21094243.jpg";